function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert } from 'antd';
import { Container, Col, Row } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ChangePasswordForm = function ChangePasswordForm(_ref) {
  var user = _ref.user;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormProcessing = _useState6[0],
    setIsFormProcessing = _useState6[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    axios.post(Common.baseApiUrl + 'changeuserpassword', {
      oldpassword: values.oldpassword,
      newpassword: values.newpassword,
      newpassword_confirmation: values.newpassword_confirmation,
      uid: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: errorMessage,
            showIcon: true
          }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "success",
            message: successMessage,
            showIcon: true
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            form: form,
            onFinish: onFinish,
            layout: "vertical",
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "oldpassword",
              label: "Ancien mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "newpassword",
              label: "Nouveau mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "newpassword_confirmation",
              label: "Confirmer mot de passe",
              rules: [{
                required: true,
                message: 'Ce champ est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input.Password, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                loading: isFormProcessing,
                htmlType: "submit",
                children: "Changer"
              })
            })]
          })]
        })
      })
    })]
  });
};
export default ChangePasswordForm;